
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.996","height":"15.998"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 73","transform":"translate(-67 -67)"}},[_c('path',{attrs:{"data-name":"Path 40793","d":"M67.888 67h14.22a.888.888 0 01.888.888v14.22a.888.888 0 01-.888.888h-14.22A.885.885 0 0167 82.11V67.888a.888.888 0 01.888-.888z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 40794","d":"M82.11 83H67.888a.89.89 0 01-.888-.89V67.888a.89.89 0 01.888-.888h14.22a.889.889 0 01.888.888v14.22a.888.888 0 01-.886.892zM67.449 67.875V82.1a.444.444 0 00.444.444h14.23a.444.444 0 00.444-.444V67.875a.444.444 0 00-.444-.444h-14.23a.445.445 0 00-.444.444z","fill":"#8f8e8c"}}),_c('path',{attrs:{"d":"M81.657 79.458h-13l.494-.748 4.177-6.293.413.493 2.461 2.934 1.844-1.727.316.467zm-11.47-.791h10.01l-2.288-3.259-1.8 1.641-.311-.383-2.4-2.8z","fill":"#a6ccc3"}}),_c('circle',{attrs:{"cx":"1.334","cy":"1.334","r":"1.334","transform":"translate(77.664 69.666)","fill":"#ff9810"}})])])
          )
        }
      }
    